
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightBacklightButtons as ObiLightBacklightButtonsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-backlight-buttons.js';
 
 
 

 
 export const ObiLightBacklightButtons = createComponent({
   react: React,
   tagName: 'obi-light-backlight-buttons',
   elementClass: ObiLightBacklightButtonsElement,
   events: {
     
   }
  });
 
 